// ===================================================================
// KAIXO - Sentry (frontend)
// ===================================================================
// Captura errores en el cliente (incluido crashes del ErrorBoundary)
// y los envía a Sentry. Activación: REACT_APP_SENTRY_DSN en .env.
// Si falta, queda inerte.
// ===================================================================

import * as Sentry from '@sentry/react';

let enabled = false;

export function initSentry() {
    const dsn = process.env.REACT_APP_SENTRY_DSN;
    if (!dsn) return false;

    try {
        Sentry.init({
            dsn,
            environment: process.env.NODE_ENV || 'development',
            release: process.env.REACT_APP_VERSION || '1.1.0',
            // Sampling bajo en prod para no saturar cuota gratis
            tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
            sendDefaultPii: false,
            ignoreErrors: [
                // Errores de red esperables (sin cobertura, WebSocket reconectando)
                'Network request failed',
                'Load failed',
                'ResizeObserver loop limit exceeded',
                // Capacitor / navegador antiguos
                'Non-Error promise rejection captured'
            ],
            beforeSend(event) {
                // No enviar si el user no ha aceptado (gancho futuro de consent)
                return event;
            }
        });
        enabled = true;
    } catch (e) {
        console.warn('[sentry] fallo al inicializar:', e?.message);
    }
    return enabled;
}

/**
 * Asociar el usuario actual a los eventos que manda Sentry. Solo el _id
 * y el idioma — nunca teléfono o email.
 */
export function setSentryUser(user) {
    if (!enabled || !user?._id) return;
    try {
        Sentry.setUser({ id: String(user._id), language: user.language });
    } catch {}
}

export function clearSentryUser() {
    if (!enabled) return;
    try { Sentry.setUser(null); } catch {}
}

export function captureError(err, extra = {}) {
    if (!enabled) return;
    try {
        Sentry.withScope(scope => {
            Object.entries(extra).forEach(([k, v]) => scope.setExtra(k, v));
            Sentry.captureException(err);
        });
    } catch {}
}

export { Sentry };
